import React, { useEffect, useState } from "react";
import "./alertRule.scss";
import { Button, Col, Popconfirm, Row, Table, Tag, Typography } from "antd";
import Icon from "../../../../components/icon/icon";
import { HandleErrors } from "../../../../utils/handleErrors";

import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { GetPermissionRes } from "../../../../interfaces/role.interface";
import { PermissionCode } from "../../../../enum/permission";
import {
  GetAlertReceiverRes,
  GetAlertRuleRes,
} from "../../../../interfaces/alert.interface";
import {
  deleteAlertRuleService,
  getAllAlertReceiverService,
  getAllAlertRuleService,
} from "../../../../services/alert.service";
import { AddAlertReceiverModal } from "../../../../components/addAlertReceiverModal/addAlertReceiverModal";
import { UpdateAlertReceiverModal } from "../../../../components/updateAlertReceiverModal/updateAlertReceiverModal";
import { AddAlertRuleModal } from "../../../../components/addAlertRuleModal/addAlertRuleModal";
import { UpdateAlertRuleModal } from "../../../../components/updateAlertRuleModal/updateAlertRuleModal";

export const AlertRule = () => {
  const health = useSelector<RootState, string>((root) => root.app.health);
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [addAlertRuleModal, setAddAlertRuleModal] = useState(false);
  const [updateAlertRuleModal, setUpdateAlertRuleModal] = useState(false);

  const [selectAlertRule, setSelectAlertRule] = useState<GetAlertRuleRes>({
    id: 0,
    active: true,
    alert_interval: "",
    condition: "",
    condition_obj: "",
    receivers: [],
    time_threshold: "",
    title: "",
    trigger_threshold: "",
    created_at: "",
  });

  const [data, setData] = useState<GetAlertRuleRes[]>([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      if(health == 'license-false'){
        return;
      }
      setLoading(true);
      const res = await getAllAlertRuleService({});

      setData(res.list);
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  const deleteAlertRule = async (item: GetAlertRuleRes) => {
    try {
      setDeleteLoading(true);
      await deleteAlertRuleService({ id: item.id });
      await getData();
      setDeleteLoading(false);
    } catch (error) {
      HandleErrors(error);
      setDeleteLoading(false);
    }
  };

  const columns = [
    {
      title: "عنوان",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "گیرنده ها",
      dataIndex: "receivers",
      key: "receivers",
      render: (receivers: GetAlertReceiverRes[]) => {
        let t = "";
        receivers.map((i) => {
          if (t.length == 0) {
            t += `${i.name}`;
          } else {
            t += `, ${i.name}`;
          }
        });

        return (
          <div>
            <Typography.Text>{t}</Typography.Text>
          </div>
        );
      },
    },
    {
      title: "وضعیت",
      dataIndex: "active",
      key: "active",
      render: (active: boolean) => {
        return (
          <div>
            {active && <Tag color={"green"}>فعال</Tag>}
            {!active && <Tag color={"red"}>غیر فعال</Tag>}
          </div>
        );
      },
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (item: any, record: any) => (
        <div className="btn-box">
          {userPermissions.find(
            (p) => p.code === PermissionCode.updateAlertRule
          ) && <div
            className="btn"
            onClick={() => {
              setSelectAlertRule(record);
              setUpdateAlertRuleModal(true);
            }}
          >
            <Icon src="/assets/icons/Pen.svg" />
          </div>}
          {userPermissions.find(
            (p) => p.code === PermissionCode.deleteAlertRule
          ) && (
            <div className="del-btn">
              <Popconfirm
                title={`حذف قانون: ${record.title}`}
                description="قانون حذف شده قابل بازیابی نیست، مطمئن هستید؟"
                onConfirm={() => {
                  deleteAlertRule(record);
                }}
                onCancel={() => {}}
                okText="حذف شود"
                cancelText="لغو"
              >
                <Button type="text" loading={deleteLoading}>
                  <i className="las la-trash delete-icon"></i>
                </Button>
              </Popconfirm>
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="AlertRule">
      {health == "license-false" && (
        <div
          style={{
            position: "absolute",
            zIndex: "100000",
            width: "100%",
            height: "100%",
            top: 0,
            right: 0,
            backdropFilter: "blur(3px)",
            backgroundColor: "rgba(255, 255, 255, 0.5)" /* optional tint */,
          }}
        ></div>
      )}
      <Row align={"middle"} justify={"space-between"} className="title-box">
        <Col>
          <Typography.Text className="title">مدیریت قوانین </Typography.Text>
        </Col>
        <Col md={5} xs={15}>
          {userPermissions.find(
            (p) => p.code === PermissionCode.createAlertReceiver
          ) && (
            <div
              className="btn-box"
              onClick={() => {
                setAddAlertRuleModal(true);
              }}
            >
              <Icon src="/assets/icons/Add - Circle.svg" />
              <Typography.Text className="title">
                افزودن قانون جدید{" "}
              </Typography.Text>
            </div>
          )}
        </Col>
      </Row>

      <Row className="table-container">
        <Col xs={24} style={{minWidth: '500px'}}>
          <Table dataSource={data} columns={columns} loading={loading} />
        </Col>
      </Row>

      <AddAlertRuleModal
        show={addAlertRuleModal}
        onClose={() => {
          getData();
          setAddAlertRuleModal(false);
        }}
      />

      <UpdateAlertRuleModal
        show={updateAlertRuleModal}
        onClose={() => {
          getData();
          setUpdateAlertRuleModal(false);
        }}
        alertRule={selectAlertRule}
      />
    </div>
  );
};
